import { Basics } from "../_app/cuchillo/core/Basics";
import { Sizes } from "../_app/cuchillo/core/Sizes";
import Main from "../main";
import Bird from "./Bird";
import FlappyBG from "./FlappyBG";
import Ground from "./Ground";
import Background from "./Background";
import Background0 from "./Background0";
import SoundController from "./SoundController";
import Tapa from "./Tapa";
import Tube from "./Tube";
import { GetBy } from "../_app/cuchillo/core/Element";
import Keyboard from "../_app/cuchillo/core/Keyboard";

export default class Flappy {
  static width = 360 * Sizes.RATIO;
  static height = 540 * Sizes.RATIO;
  static offset = 100 * Sizes.RATIO;
  static isEnabled = false;
  static isEnd = false;

  static tick = 0;
  static grid = 5;
  static gridSize = this.height / this.grid;
  static bird;
  static ground;
  static background;
  static background0;
  static tube;
  static speed = 10;
  static _score = 0;
  static state = -1;

  static idTimer = null;

  static defaults = {
    speed: 15,
    respawn: 1,
    securezone: 100 * Sizes.RATIO,
    grid: 8,
    gridSize: this.height / this.grid
  }

  static get score() {
    return this._score;
  }
  static set score(value) {
    this._score = value;
    this.domScore.innerHTML = value;
    this.domScoreA.innerHTML = Math.floor(value * 0.6);
    this.domScoreB.innerHTML = Math.floor(value * 0.89);
    this.domScoreC.innerHTML = Math.floor(value * 0.22);
  }

  static init(__container = document.getElementById("FlappyVicio"), __id = 'Flappy__Canvas') {
    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');

    this.domScore = GetBy.selector("[data-points-main]", this.container)[0];
    this.domScoreA = GetBy.selector("[data-points-a]", this.container)[0];
    this.domScoreB = GetBy.selector("[data-points-b]", this.container)[0];
    this.domScoreC = GetBy.selector("[data-points-c]", this.container)[0];

    this.canvas.id = __id;
    __container.appendChild(this.canvas);

    let itemsLoaded = 0;
    const elementLoaded = () => {
      itemsLoaded++;
      if (itemsLoaded === 4) {
        this.show();
      }
    }

    //
    this.tapa = new Tapa();
    this.bird = new Bird(elementLoaded);
    this.bg = new FlappyBG(elementLoaded);
    this.ground = new Ground(elementLoaded);
    this.background = new Background(elementLoaded);
    this.background0 = new Background0(elementLoaded);
    Tube.preloadImages(elementLoaded);

    this.defaults.securezone = Number(__container.dataset.securezone) * this.bird.size.height || this.defaults.securezone;
    this.defaults.speed = Number(__container.dataset.speed) || this.defaults.speed;
    this.defaults.respawn = Number(__container.dataset.respawn) || this.defaults.respawn;
    this.defaults.gridSize = (this.height - this.defaults.securezone * 2)  / this.defaults.grid;
    this.speed = this.defaults.speed * Sizes.RATIO;
    
    this.limit0 = -this.bird.size.height;
    this.limit1 = this.height + this.bird.size.height;

    document.addEventListener(Basics.downEvent, (e) => {
      if (this.state === 0) {
          //this.start();        
      } else if (this.state === 1) {
        this.bird.jump();
      } else if (this.state === 2) {
        //this.reset();
      }
    });

    document.addEventListener('keydown', (e) => this.bird.jump());

    this.resize();
  }

  static show() {
    //Main.onShow();

    this.bg.draw(this.ctx);
    this.background0.draw(this.ctx);
    this.background.draw(this.ctx);
    this.ground.draw(this.ctx);
    this.bird.draw(this.ctx);
    this.tapa.draw(this.ctx);
    this.tapa.hide();
    this.state = 0;
  }

  static hide() {
    this.tapa.show(() => {
      this.state = 2;
      this.speed = 0;
      Main.onComplete(this.score);
    });
  }

  static start() {
    this.reset();
    
    setTimeout(()=> {
      SoundController.preloadSounds(() => {
        Tube.init();
        this.state = 1;
      });
    }, 200);
  }

  static reset() {
    this.isEnd = false;
    this.bird.reset();
    Tube.reset();
    this.score = 0;
    this.speed = this.defaults.speed * Sizes.RATIO;
    this.show();
  }

  static loop() {
    this.tick++;
    
    if (this.state === 1) {
      this.bird.update();
      this.background0.update(this.speed);
      this.background.update(this.speed);
      this.ground.update(this.speed);

      let isCollision = false;
      let passedTube = false;
      for (const tube of Tube.tubes) {
        if (!tube.passed && this.bird.position.x > tube.position.x + tube.size.width) {
          tube.passed = true;
          passedTube = true;
        }

        if (this.isColliding(this.bird, tube)) {
          isCollision = true;
        }

        if (passedTube) {
          this.score++;
          SoundController.playSound('score');
        }

        passedTube = false;
      }

      if (this.bird.position.y < this.limit0 || this.bird.position.y > this.limit1) {
        isCollision = true;
      }

      if (isCollision && !this.isEnd) {
        this.isEnd = true;
       
        this.bird.die();

        this.idTimer = setTimeout(() => {
          Tube.hide();
          this.hide();
        }, 1000);
      }
    }

    this.ctx.clearRect(0, 0, this.width, this.height);
    this.bg.draw(this.ctx);
    this.background0.draw(this.ctx);
    this.background.draw(this.ctx);
    this.ground.draw(this.ctx);
    Tube.update(this.ctx, this.speed);
    this.bird.draw(this.ctx);
    this.tapa.draw(this.ctx);
  }

  static isColliding(obj1, obj2) {
    const hitArea = {
        x: obj1.position.x,
        y: obj1.position.y,
        width: obj1.size.hitWidth,
        height: obj1.size.hitHeight
    };

    return (
        hitArea.x < obj2.hitArea.x + obj2.hitArea.width &&
        hitArea.x + hitArea.width > obj2.hitArea.x &&
        hitArea.y < obj2.hitArea.y + obj2.hitArea.height &&
        hitArea.y + hitArea.height > obj2.hitArea.y
    );
  }

  static resize() {
    this.canvas.setAttribute('width', this.width);
    this.canvas.setAttribute('height', this.height);
  }

  static dispose() {
    clearTimeout(this.idTimer);
    this.score = 0;
    // Eliminar referencias a los elementos del DOM
  this.canvas.remove();
  this.domScore = null;

  // Liberar recursos de los objetos
  this.bird.dispose();
  this.bg.dispose();
  this.background0.dispose();
  this.background.dispose();
  this.ground.dispose();
  Tube.dispose();
  SoundController.dispose();

  // Restablecer propiedades estáticas a sus valores iniciales
  this.canvas = null;
  this.ctx = null;
  this.domScore = null;
  this.isEnabled = false;
  this.isEnd = false;
  this.bird = null;
  this.background0 = null;
  this.background = null;
  this.ground = null;
  this.tube = null;
  this.speed = 0;
  this._score = null;
  this.state = null;
  this.defaults = {
    speed: 10,
    respawn: 1,
    securezone: 100 * Sizes.RATIO,
    grid: 8,
    gridSize: this.height / this.grid
  };
  this.limit0 = null;
  this.limit1 = null;
  }
}

